export default "/images/728a558dfed2dcc826738e23ccfe320e.avif";